import { generateApiActionTypes } from 'utils/actions/generateActionTypes'
import { ENDPOINTS } from 'utils/api/callApi'
import { IBulkQuotingFormState } from './types'

export const BULK_QUOTING_ACTION_TYPES = generateApiActionTypes('BULK_QUOTING_TOOL')
export const getBulkSpotRates = (form: IBulkQuotingFormState) => {
  const { email, lanesFile } = form
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: ENDPOINTS.bulkSpotRates,
        method: 'POST',
        body: {
          email,
          file: lanesFile,
        },
      },
      actionTypes: Object.keys(BULK_QUOTING_ACTION_TYPES),
    },
    type: undefined,
  }
}
